import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IProjectParticipantNote } from "../../utils/types/models";

export default createEntityReducer<IProjectParticipantNote>(Endpoint.ProjectParticipantNotes, Endpoint.ProjectParticipantNotesList);
